export const iconFontAwesomeHouseholdMugSaucer = (
	<i className="fa-solid fa-mug-saucer"></i>
);
